import { Button, Flex, Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import Checkbox from 'react-custom-checkbox';
import { Check } from 'react-feather';

const ReferenceCard = ({
  reference,
  select,
  toggleOption,
  checked,
  onDelete,
  onSend,
}: ReferenceCardProps): JSX.Element => {
  const { id, firstname, lastname, created, status } = reference;
  return (
    <Flex
      position="relative"
      direction="column"
      bg={status === 'completed' ? 'custom.levoBlue' : 'reference.containerBg'}
      borderRadius="8px"
    >
      <Flex
        direction="row"
        width="100%"
        alignItems="center"
        px={3}
        pt={3}
        justifyContent="space-between"
      >
        <Text
          fontWeight={700}
          fontSize="20px"
          lineHeight="24px"
          letterSpacing="3%"
          color={status === 'completed' ? 'white' : 'custom.levoLightBlack'}
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
        >
          {`${firstname} ${lastname}`}
        </Text>
        {select && (
          <Flex direction="column" zIndex={1}>
            <Checkbox
              checked={checked}
              icon={
                <Flex flex={1} bgColor="white" alignItems="center">
                  <Check size={20} color="#51DACF" />
                </Flex>
              }
              borderColor="white"
              borderRadius={8}
              style={{ overflow: 'hidden', backgroundColor: 'white' }}
              size={22}
              onChange={(val: boolean) => toggleOption({ id, val })}
            />
          </Flex>
        )}
      </Flex>
      <Flex direction="row" justifyContent="space-between" px={3}>
        <Flex direction="column">
          <Flex
            mt={1}
            bg={
              status === 'completed'
                ? 'reference.statusGreenBg'
                : 'reference.statusBrownBg'
            }
            borderRadius="4px"
            height="18px"
            width="fit-content"
            alignItems="center"
          >
            <Text
              fontWeight={700}
              fontSize="12px"
              lineHeight="14.4px"
              letterSpacing="3%"
              mr={1}
              ml={1}
              color={
                status === 'completed'
                  ? 'reference.textBrown'
                  : 'reference.textGray'
              }
            >
              {status === 'completed' ? 'Completed' : 'Pending'}
            </Text>
          </Flex>
          <Flex direction="row" mt={3}>
            <Text
              fontWeight={700}
              fontSize="14px"
              lineHeight="16.8px"
              letterSpacing="5%"
              color={status === 'completed' ? 'white' : 'custom.levoLightBlack'}
            >
              Sent:
            </Text>
            <Text
              fontWeight={700}
              fontSize="14px"
              lineHeight="16.8px"
              letterSpacing="5%"
              marginBottom="6px"
              color={status === 'completed' ? 'white' : 'custom.levoLightBlack'}
            >
              &nbsp;&nbsp;
              {created?.seconds ? format(created?.seconds * 1000, 'MM/dd') : ''}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        direction="row"
        justifyContent="space-between"
        width="100%"
        bg={
          status === 'completed'
            ? 'custom.levoSeaBlue'
            : 'custom.levoLightBlack'
        }
        borderRadius="0 0 8px 8px"
      >
        <Button
          color="custom.levoWhite"
          bg={
            status === 'completed'
              ? 'custom.levoSeaBlue'
              : 'custom.levoLightBlack'
          }
          mt={1}
          p={4}
          onClick={() => {
            if (onDelete) onDelete(id);
          }}
          _hover={{ bg: 'transparent' }}
          borderRadius="0 0 0 8px"
        >
          <Text textStyle="small">Delete</Text>
        </Button>
        {status === 'completed' && (
          <Button
            color="custom.levoWhite"
            bg={
              status === 'completed'
                ? 'custom.levoSeaBlue'
                : 'custom.levoLightBlack'
            }
            mt={1}
            p={4}
            onClick={() => {
              if (onSend) {
                onSend(id);
              }
            }}
            _hover={{ bg: 'transparent' }}
            borderRadius="0 0 8px 0"
          >
            <Text textStyle="small">Send</Text>
          </Button>
        )}
      </Flex>
      {select && (
        <Flex
          position="absolute"
          bg="#5F5F5F"
          opacity="30%"
          top={0}
          right={0}
          bottom={0}
          left={0}
          borderRadius="8px"
        />
      )}
    </Flex>
  );
};

export default ReferenceCard;
